export function lazyWithRetry<T>(loader: () => Promise<T>): () => Promise<T> {
  return async () => {
    const maxAttempts = 5;
    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      try {
        return await loader();
      } catch (error) {
        if (attempt === maxAttempts - 1) throw error;
        const delay = Math.min(150 * 2 ** attempt, 1200);
        console.warn(
          `[lazyWithRetry] dynamic import failed, retrying in ${delay}ms ` +
            `(attempt ${attempt + 2}/${maxAttempts})`,
          error
        );
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
    throw new Error('Dynamic import retry loop ended unexpectedly');
  };
}
